import { __read } from "tslib";
import React, { useState, useEffect } from 'react';
import { Modal } from './Modal';
export var EditLineDiscountMultipleModal = function (props) {
    var shouldHide = props.shouldHide, show = props.show, onChangeDiscountMultiple = props.onChangeDiscountMultiple;
    var _a = __read(useState(0), 2), lineDiscount = _a[0], setLineDiscount = _a[1];
    var textInput = React.createRef();
    var _b = __read(useState('all'), 2), action = _b[0], setAction = _b[1];
    useEffect(function () {
        textInput.current && textInput.current.focus();
        textInput.current && textInput.current.select();
    }, []);
    var onClickConfirm = function () {
        if (onChangeDiscountMultiple) {
            onChangeDiscountMultiple(action, lineDiscount);
            shouldHide();
        }
    };
    var onChangeValue = function (e) {
        setLineDiscount(e.target.value);
    };
    var renderConfirm = function () { return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "edit-navorder-confirm" },
            React.createElement("h5", { className: "text-center", style: { marginBottom: '40px', marginTop: '10px' } }, "Please choose how you would like to proceed:"),
            React.createElement("div", { style: { padding: '20px' } },
                React.createElement("div", { className: "form-control" },
                    React.createElement("div", { className: "pretty p-default p-round" },
                        React.createElement("input", { type: "radio", name: "editNavOrderOptions", checked: action === 'all', onChange: function () { setAction('all'); } }),
                        React.createElement("div", { className: "state" },
                            React.createElement("label", null,
                                React.createElement("strong", null, "On all items:"),
                                " Set discount on all items in basket"))),
                    React.createElement("div", { className: "pretty p-default p-round" },
                        React.createElement("input", { type: "radio", name: "editNavOrderOptions", checked: action === 'filtered', onChange: function () { setAction('filtered'); } }),
                        React.createElement("div", { className: "state" },
                            React.createElement("label", null,
                                React.createElement("strong", null, "On filtered items only:"),
                                " Set discount on the filtered items only."))),
                    React.createElement("div", { className: "form-control" },
                        React.createElement("label", null, "Discount: "),
                        React.createElement("input", { ref: textInput, type: "number", name: "salespersonNote", value: lineDiscount, onChange: onChangeValue, placeholder: 'Line discount', max: 100, min: 0, onKeyDown: function (event) { return event.key === 'Enter' && onClickConfirm(); } }))))),
        React.createElement("div", { className: "delete-order-modal__footer" },
            React.createElement("button", { className: "btn", onClick: function () { return onClickConfirm(); } }, "Update discount"),
            React.createElement("button", { className: "btn", onClick: function () { return shouldHide(); } }, "Cancel")))); };
    return (React.createElement(Modal, { children: renderConfirm(), size: 'sm', hide: shouldHide, isShowing: show, bodyClasses: 'confirm-modal', hideFooter: true }));
};
//# sourceMappingURL=EditLineDiscountMultipleModal.js.map